import type { HTMLAttributes } from "react";

type GapProps = {
  gap?: string;
};

export const Row = ({
  gap = "16px",
  className,
  style,
  ...props
}: HTMLAttributes<HTMLDivElement> & GapProps) => (
  <div
    className={`flex w-full flex-row ${className ?? ""}`}
    style={{ gap, ...style }}
    {...props}
  />
);

export const Col = ({
  gap = "18px",
  className,
  style,
  ...props
}: HTMLAttributes<HTMLDivElement> & GapProps) => (
  <div
    className={`flex w-full flex-grow flex-col ${className ?? ""}`}
    style={{ gap, ...style }}
    {...props}
  />
);
